import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    width: '35%',
    className: 'bold',
    render: (data, type, row, meta) => {
      const isDiscarded = row['discarded'] === 'true'
      const name = isDiscarded ? data : <a href={`/admin/dashboards/${row.DT_RowId}/overview`}>{data}</a>
      return renderToString(
        <div>
          {name}
          {isDiscarded && <><br />
            <button className="button secondary small margin-top restore-dashboard" data-dashboard-id={row.DT_RowId}>Restore dashboard</button>
          </>}
        </div>
      )
    }
  },
  {
    data: 'status',
    width: '15%',
    orderable: false,
    render: (data, type, row, meta) => {
      const getClass = () => {
        const status = row['status']
        if (status === 'live') return 'accent'
        if (status === 'closed') return 'blue-100'
        return 'purple-60' // draft
      }

      return renderToString(
        <span className={`bold ${getClass()} capitalize`}>{row['status']}</span>
      )
    }
  },
  {
    data: 'target_count',
    width: '25%',
  },
  { data: 'created_at', visible: false },
]

const headers = ['Name', 'Status', 'Number of people']

const filters = [
  {
    name: 'Status', column: 1, kind: 'radio', options: [
      { value: 'draft', label: 'Draft' },
      { value: 'live', label: 'Live' },
      { value: 'closed', label: 'Closed' },
    ]
  },
]

const sorters = [
  { column: 3, label: 'Created', order: 'desc' },
  { column: 2, label: 'Number of people', order: 'desc' },
  { column: 0, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 0, label: 'Alphabetically (Z-A)', order: 'desc' },
]

const order = [[3, "desc"]]

export { columns, headers, filters, sorters, order }
